import { ArrowBackIosRounded, KeyboardArrowRight, Search } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { SearchField, ListItem } from './index';
import { IRole } from 'views/backoffice/roles/types';
import { useTenantSelector } from 'contexts/TenantSelectorContext';
import { RoleSelectorMode } from '../types';

export const RoleSelector = () => {
    const { selectedTenant, setSelectedRole, selectedRole, searchText, setSearchText, setRoleSelectorMode, roleSelectorMode } =
        useTenantSelector();

    const unSelectTenant = () => setRoleSelectorMode(RoleSelectorMode.NONE);
    const filteredRoles = useMemo(
        () => selectedTenant?.roles?.filter((role) => role.name.toLowerCase().includes(searchText.toLowerCase())),
        [selectedTenant, searchText]
    );

    return (
        <>
            <Box position="sticky" top={0} zIndex={1} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, pb: '8px' })}>
                {selectedTenant && selectedTenant.roles && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        {roleSelectorMode === RoleSelectorMode.MULTIPLE && (
                            <IconButton
                                sx={(theme) => ({ ml: '8px', backgroundColor: theme.palette.primary[300] })}
                                onClick={() => unSelectTenant()}
                            >
                                <ArrowBackIosRounded sx={{ fontSize: '20px' }} />
                            </IconButton>
                        )}
                        <Box width="100%">
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start', width: '100%', p: '8px' }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px',
                                        '&:hover': {
                                            cursor: roleSelectorMode === RoleSelectorMode.SINGLE ? 'default' : 'pointer',
                                            textDecoration: roleSelectorMode === RoleSelectorMode.SINGLE ? 'none' : 'underline'
                                        }
                                    }}
                                    onClick={() => unSelectTenant()}
                                >
                                    {selectedTenant?.tenant?.name}
                                </Typography>
                                <KeyboardArrowRight sx={{ fontSize: '20px' }} />
                                <Typography
                                    sx={(theme) => ({
                                        color: theme.palette.primary.dark,
                                        fontSize: '16px',
                                        fontWeight: 700
                                    })}
                                >
                                    Roles
                                </Typography>
                            </Box>
                            <SearchField
                                InputProps={{
                                    disableUnderline: true,
                                    sx: (theme) => ({
                                        backgroundColor: theme.palette.primary[300],
                                        borderRadius: '16px',
                                        '& input': { padding: '8px 12px' }
                                    }),
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search htmlColor="#D9D9D9" />
                                        </InputAdornment>
                                    )
                                }}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                sx={{ px: '8px', mb: '16px', height: '20px' }}
                                InputLabelProps={{ sx: { paddingLeft: 2 } }}
                                placeholder="Find in list"
                                fullWidth
                                type="search"
                                variant="filled"
                            />
                        </Box>
                    </Box>
                )}
            </Box>
            <Box
                sx={{
                    height: '100%',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {selectedTenant &&
                    filteredRoles &&
                    filteredRoles.map((filteredRole) => (
                        <ListItem
                            key={filteredRole.id}
                            item={filteredRole}
                            selected={selectedRole?.id === filteredRole.id}
                            onChange={(role) => setSelectedRole(role as Pick<IRole, 'name' | 'id'> | null)}
                        />
                    ))}
            </Box>
        </>
    );
};
